// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3_fVe","signatureBlock":"Footer_signatureBlock__ztJvB","signature":"Footer_signature__1GDPY"};